"use client";
import React, { useRef } from "react";
import style from "./CasesHero.module.scss";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

export const CasesHero = ({ messages }: { messages: any }) => {
  const heroCasesRef = useRef(null);

  useGSAP(
    () => {
      gsap.fromTo(
        [`.${style.firstWord}`, `.${style.secondWord}`, `.${style.lastWord}`],
        {
          x: gsap.utils.wrap(["-50%", "-25%", "50%"]),
          opacity: 0,
        },
        {
          x: "0%",
          duration: 1,
          opacity: 1,
          ease: "power4.out",
        }
      );
      gsap.fromTo(
        ".paragraph",
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 2,
          ease: "power4.out",
        }
      );
    },
    { scope: heroCasesRef }
  );

  return (
    <section ref={heroCasesRef} className={style.sectionContainer}>
      <div className="container">
        <div className={style.textContainer}>
          <h1 className="title-section">
            <span className={style.firstWord}>{messages.first_word}</span>
            <span className={`title-outline ${style.secondWord}`}>
              {messages.second_word}
            </span>
            <span className={style.lastWord}>{messages.last_word}</span>
          </h1>
          <p className="paragraph">{messages.description}</p>
        </div>
      </div>
    </section>
  );
};
